import { render, staticRenderFns } from "./CampaignCoupons.vue?vue&type=template&id=1956d0ee"
import script from "./CampaignCoupons.vue?vue&type=script&lang=js"
export * from "./CampaignCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports